module.exports = __webpack_public_path__ + "img/message-settings.7484bbfe.png";